import { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getQueryObject, getQueryString } from '../../../../universal/ui/utils/url';
import { omit } from '../../utils/object';
import { saveToLibrary } from '../../actions/library';
import { followUser } from '../../actions/follow';

class QueryHandler extends Component {
  componentDidMount() {
    const {
      isAuthenticated,
      location,
      history,
      documents,
    } = this.props;

    const query = getQueryObject(location.search);
    const { save, follow } = query || {};
    const doc = documents[save];
    const handled = [];

    if (isAuthenticated && doc) {
      this.props.saveToLibrary({ doc });
      handled.push('save');
    }

    if (isAuthenticated && follow) {
      this.props.followUser(follow);
      handled.push('follow');
    }

    if (handled.length) {
      history.replace({
        ...location,
        search: `?${getQueryString(omit(handled, query))}`
      });
    }
  }

  render() {
    return null;
  }
}

QueryHandler.defaultProps = {
  isAuthenticated: false,
  location: {},
  history: {},
  saveToLibrary: () => {},
  followUser: () => {},
};

QueryHandler.propTypes = {
  isAuthenticated: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    replace: PropTypes.func,
  }),
  saveToLibrary: PropTypes.func,
  followUser: PropTypes.func,
};

const mapStateToProps = ({
  documents,
  session: { isAuthenticated },
}) => ({
  documents,
  isAuthenticated,
});

const mapDispatchToProps = {
  saveToLibrary,
  followUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(QueryHandler));



// WEBPACK FOOTER //
// ./src/universal/ui/components/App/QueryHandler.js